// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"031878c6","298":"229412ca","986":"b6a54faa"}[chunkId] + ".chunk.js";
};